import axios from 'axios';
import {
  parseHeaderForLinks,
  loadMoreDataWhenScrolled,
  ICrudGetAction,
  ICrudGetAllAction,
  ICrudPutAction,
  ICrudDeleteAction
} from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IApp, defaultValue } from 'app/shared/model/app.model';

export const ACTION_TYPES = {
  FETCH_APP_LIST: 'app/FETCH_APP_LIST',
  FETCH_APP: 'app/FETCH_APP',
  CREATE_APP: 'app/CREATE_APP',
  UPDATE_APP: 'app/UPDATE_APP',
  DELETE_APP: 'app/DELETE_APP',
  RESET: 'app/RESET'
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IApp>,
  entity: defaultValue,
  links: { next: 0 },
  updating: false,
  totalItems: 0,
  updateSuccess: false
};

export type AppState = Readonly<typeof initialState>;

// Reducer

export default (state: AppState = initialState, action): AppState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_APP_LIST):
    case REQUEST(ACTION_TYPES.FETCH_APP):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true
      };
    case REQUEST(ACTION_TYPES.CREATE_APP):
    case REQUEST(ACTION_TYPES.UPDATE_APP):
    case REQUEST(ACTION_TYPES.DELETE_APP):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true
      };
    case FAILURE(ACTION_TYPES.FETCH_APP_LIST):
    case FAILURE(ACTION_TYPES.FETCH_APP):
    case FAILURE(ACTION_TYPES.CREATE_APP):
    case FAILURE(ACTION_TYPES.UPDATE_APP):
    case FAILURE(ACTION_TYPES.DELETE_APP):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.FETCH_APP_LIST):
      const links = parseHeaderForLinks(action.payload.headers.link);
      return {
        ...state,
        links,
        loading: false,
        totalItems: action.payload.headers['x-total-count'],
        entities: loadMoreDataWhenScrolled(state.entities, action.payload.data, links)
      };
    case SUCCESS(ACTION_TYPES.FETCH_APP):
      return {
        ...state,
        loading: false,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.CREATE_APP):
    case SUCCESS(ACTION_TYPES.UPDATE_APP):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.DELETE_APP):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {}
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

const apiUrl = 'api/apps';

// Actions

export const getEntities: ICrudGetAllAction<IApp> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_APP_LIST,
    payload: axios.get<IApp>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`)
  };
};

export const getEntity: ICrudGetAction<IApp> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_APP,
    payload: axios.get<IApp>(requestUrl)
  };
};

export const createEntity: ICrudPutAction<IApp> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_APP,
    payload: axios.post(apiUrl, cleanEntity(entity))
  });
  return result;
};

export const updateEntity: ICrudPutAction<IApp> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_APP,
    payload: axios.put(apiUrl, cleanEntity(entity))
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IApp> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_APP,
    payload: axios.delete(requestUrl)
  });
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET
});
